import { motion } from 'framer-motion';
import { IconCheck } from '@tabler/icons-react';
import { Button } from '@shared/ui/button/button';
import { itemVariants, sectionVariants } from '@shared/lib/onboarding-motion';
import s from './onboarding-complete-step.module.scss';

export const OnboardingCompleteStep = ({
	title,
	subtitle,
	buttonLabel,
	onSubmit,
	isPending,
}) => {
	return (
		<motion.div className={s.slideWrapper} variants={sectionVariants} initial="initial" animate="animate">
			<motion.div className={s.completePanel} variants={sectionVariants}>
				<motion.div
					className={s.completeIcon}
					variants={itemVariants}
					initial={{ opacity: 0, scale: 0.7, rotate: -8 }}
					animate={{ opacity: 1, scale: 1, rotate: 0 }}
					transition={{ type: 'spring', stiffness: 360, damping: 22 }}
				>
					<IconCheck size={32} stroke={3} />
				</motion.div>
				<motion.div className={s.titleWrapper} variants={itemVariants}>
					<p className={s.title}>{title}</p>
					<p className={s.subtitle}>{subtitle}</p>
				</motion.div>
				<motion.div className={s.btns} variants={itemVariants}>
					<Button
						label={buttonLabel}
						size="small"
						className={s.button}
						disabled={isPending}
						fetching={isPending}
						onClick={onSubmit}
					/>
				</motion.div>
			</motion.div>
		</motion.div>
	);
};
